<script>
import eventBus from '@/js/util/EventBus'
import defaultClass from '@/js/util/mixins/defaultClass'

export default {
  provide() {
    return {
      header: this,
    }
  },
  mixins: [defaultClass],
  props: {
    tag: {
      type: String,
      default: 'header',
    },
  },
  data() {
    return {
      toggle: false,
      element: undefined,
      hideElement: undefined,
    }
  },
  created() {
    this.$on('toggle', this.handleMenuOpen)
    this.$on('hide:element', this.handleHideElement)
  },

  mounted() {
    [this.element] = document.getElementsByTagName('body')
  },

  methods: {
    handleHideElement(hide) {
      this.hideElement = hide
    },
    handleMenuOpen(toggle) {
      this.toggle = toggle

      const { element } = this
      if (element === undefined) {
        return
      }

      this.handleMenuKeyEvent(toggle)
      element.classList.toggle('overflow-hidden')
    },
    handleMenuKeyEvent(toggle) {
      if (toggle) {
        document.onkeyup = ({ key }) => {
          if (key !== 'Escape') {
            return
          }
          eventBus.$emit('force:close')
        }
        return
      }

      document.onkeyup = null
    },
  },
  render(createElement) {
    const computedClass = {
      [`${this.defaultClass}--translate-y`]: this.hideElement,
    }
    return createElement(this.tag, { class: computedClass }, this.$slots.default)
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/HeaderContainer.vue